// src/components/ServerDataExtraction/ExtractionOptions.jsx
import React from 'react';
// Accept options, onChange, onExtract, isLoading, disabled
const ExtractionOptions = ({ options, onChange, onExtract, isLoading, disabled }) => {
  const handleOptionChange = (key) => (e) => {
    onChange({
      ...options,
      [key]: e.target.type === 'checkbox' ? e.target.checked : e.target.value
    });
  };

return (
    // Apply disabled styling and prevent pointer events if disabled
    // Updated styling to match SearchOptions: removed gradient-bg-blue, adjusted hover effects
    <div className={`bg-dark-600 rounded-2xl p-6 transition-medium border border-dark-400 hover:shadow-md transform-gpu hover:scale-[1.005] h-full flex flex-col ${disabled ? 'opacity-60 pointer-events-none' : ''}`}>
      {/* Background glow effects removed */}
      {/* <div className="absolute -right-10 -top-10 w-32 h-32 bg-accent-blue opacity-5 rounded-full blur-xl"></div> */}
      {/* <div className="absolute -left-10 -bottom-10 w-32 h-32 bg-accent-green opacity-5 rounded-full blur-xl"></div> */}

      <h3 className="font-bold text-lg mb-5 flex items-center group relative z-10">
        <div className="w-8 h-8 rounded-lg bg-accent-blue/20 flex items-center justify-center mr-2 transform-gpu group-hover:rotate-12 transition-medium">
          <i className="fas fa-sliders-h text-accent-blue"></i>
        </div>
        Extraction Options
      </h3>

<div className="flex-1 space-y-5 relative z-10"> {/* Increased spacing like SearchOptions */}
        {[
          // ... (options array remains the same)
            { key: 'serverInfo', label: 'Server Information', description: 'Basic server info, IP, version, status', icon: 'fa-info-circle' },
            { key: 'motd', label: 'MOTD', description: 'Message of the day with formatting', icon: 'fa-quote-right' },
            { key: 'serverIcon', label: 'Server Icon', description: 'Download server\'s icon (64x64)', icon: 'fa-image' },
            { key: 'playerList', label: 'Player List', description: 'Online players with names if available', icon: 'fa-users' },
            { key: 'pluginList', label: 'Plugin List', description: 'Detect server plugins if exposed', icon: 'fa-puzzle-piece' },
            { key: 'deepScan', label: 'Deep Scan', description: 'Try advanced methods to extract more data', icon: 'fa-search-plus' },
        ].map((option) => (
          // Apply hover effect to the container div for each option
          <div
            key={option.key}
            className="transform-gpu transition-medium hover:scale-[1.02]"
          >
<label
  className={`flex items-center space-x-3 p-3 rounded-xl transition-medium ${
    options[option.key] 
      ? 'bg-accent-blue/5' 
      : 'hover:bg-dark-500'
  } ${disabled ? '' : 'cursor-pointer'}`}
>
              <input
                type="checkbox"
                checked={options[option.key]}
                onChange={handleOptionChange(option.key)}
                // Styling similar to SearchOptions checkbox
                className="accent-accent-blue h-5 w-5 border-dark-400 rounded focus:ring-accent-blue/50 transform-gpu hover:scale-110 transition-medium bg-dark-400 focus:ring-offset-dark-500"
                disabled={disabled} // Disable the checkbox itself
              />
              <div className="flex items-center">
                <i className={`fas ${option.icon} text-accent-blue mr-3 text-sm`}></i>
                <div>
                  <span className="font-medium group-hover:text-accent-blue transition-medium">{option.label}</span>
                  <p className="text-xs text-gray-400 group-hover:text-gray-300 transition-medium mt-0.5">{option.description}</p>
                </div>
              </div>
            </label>
          </div>
        ))}
      </div>

      <div className="space-y-3 mt-6 relative z-10">
        <div className="transform-gpu hover:scale-[1.02] transition-medium">
          <label className="block text-xs text-gray-400 mb-1 group hover:text-white transition-medium">
            Method Timeout (ms)
            <span className="ml-2 text-accent-blue opacity-0 group-hover:opacity-100 transition-medium">Adjust scan speed</span>
          </label>
          <input
            type="number"
            value={options.timeout}
            onChange={handleOptionChange('timeout')}
            className="w-full bg-dark-500 rounded-lg py-2 px-3 text-sm border border-dark-400 focus:outline-none focus:ring-1 focus:ring-accent-blue/50 hover:border-dark-300 transition-medium"
            disabled={disabled} // Disable input
          />
        </div>

        <div className="transform-gpu hover:scale-[1.02] transition-medium">
          <label className="block text-xs text-gray-400 mb-1 group hover:text-white transition-medium">
            Output Format
            <span className="ml-2 text-accent-blue opacity-0 group-hover:opacity-100 transition-medium">Choose report type</span>
          </label>
          <select
            value={options.outputFormat}
            onChange={handleOptionChange('outputFormat')}
            className="w-full bg-dark-500 rounded-lg py-2 px-3 text-sm border border-dark-400 focus:outline-none focus:ring-1 focus:ring-accent-blue/50 hover:border-dark-300 transition-medium appearance-none"
            disabled={disabled} // Disable select
          >
            <option value="json">JSON</option>
            <option value="txt">Plain Text</option>
            <option value="html">HTML Report</option>
            <option value="xml">XML</option>
          </select>
        </div>
      </div>

      <div className="mt-6 relative z-10">
        <button
          // Apply disabled styles based on isLoading OR the main disabled prop
          className={`w-full py-3 bg-gradient-to-r from-accent-blue to-accent-green text-white rounded-xl text-sm font-medium transition hover:opacity-90 flex items-center justify-center transform-gpu hover:-translate-y-0.5 hover:shadow-glow active:translate-y-0 active:shadow-inner ${isLoading || disabled ? 'opacity-60 cursor-not-allowed hover:shadow-none hover:translate-y-0' : ''}`}
          onClick={onExtract}
          disabled={isLoading || disabled} // Disable button if loading OR parent says so
        >
          <i className={`fas ${isLoading ? 'fa-spinner animate-spin' : 'fa-download'} mr-2`}></i>
          {isLoading ? 'Extracting...' : 'Extract Server Data'}
        </button>
      </div>
    </div>
  );
};

export default ExtractionOptions;